<template>
  <div class="month-day-picker">
    <b-form-group>
      <b-row>
        <!-- Month Selection -->
        <b-col cols="8">
          <n-single-select
            :key="$t('select_month')"
            v-model="selectedMonth"
            selection-key="value"
            selection-label="text"
            required
            :reduce="true"
            :options="monthOptions"
            @input="emitChange"
          />
        </b-col>

        <!-- Day Selection -->
        <b-col cols="4">
          <b-form-group>
            <n-single-select
              :key="$t('select_day')"
              v-model="selectedDay"
              selection-key="value"
              selection-label="text"
              placeholder="Day"
              required
              :reduce="true"
              :options="dayOptions"
              :readonly="!selectedMonth"
              @input="emitChange"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form-group>
  </div>
</template>

<script>
  import { BFormSelect, BFormGroup, BRow, BCol } from 'bootstrap-vue';
  import NSingleSelect from './NSingleSelect.vue';

  export default {
    name: 'MonthDayPicker',
    components: {
      BFormSelect,
      BFormGroup,
      BRow,
      BCol,
      NSingleSelect
    },
    props: {
      value: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        selectedMonth: '',
        selectedDay: ''
      };
    },
    computed: {
      dayOptions() {
        if (!this.selectedMonth) {
          return [{ value: '', text: this.$t('select_day') }];
        }

        const daysInMonth = this.getDaysInMonth(this.selectedMonth);
        const days = [{ value: '', text: this.$t('select_day') }];

        for (let i = 1; i <= daysInMonth; i++) {
          const value = i.toString().padStart(2, '0');
          days.push({ value, text: i.toString() });
        }

        return days;
      },
      monthOptions() {
        return [
          { value: '', text: this.$t('select_month') },
          { value: '01', text: this.$t('month_name.jan') },
          { value: '02', text: this.$t('month_name.feb') },
          { value: '03', text: this.$t('month_name.mar') },
          { value: '04', text: this.$t('month_name.apr') },
          { value: '05', text: this.$t('month_name.may') },
          { value: '06', text: this.$t('month_name.jun') },
          { value: '07', text: this.$t('month_name.jul') },
          { value: '08', text: this.$t('month_name.aug') },
          { value: '09', text: this.$t('month_name.sep') },
          { value: '10', text: this.$t('month_name.oct') },
          { value: '11', text: this.$t('month_name.nov') },
          { value: '12', text: this.$t('month_name.dec') }
        ];
      }
    },
    methods: {
      getDaysInMonth(month) {
        const year = new Date().getFullYear();
        return new Date(year, parseInt(month), 0).getDate();
      },
      emitChange() {
        if (this.selectedMonth && this.selectedDay) {
          const currentYear = new Date().getFullYear();
          const dateStr = `${currentYear}-${this.selectedMonth}-${this.selectedDay}`;
          this.$emit('input', dateStr);
        } else {
          console.log('No month or day selected');
          this.$emit('input', '');
        }
      },
      initializeFromValue() {
        if (this.value) {
          const date = new Date(this.value);
          this.selectedMonth = (date.getMonth() + 1)
            .toString()
            .padStart(2, '0');
          this.selectedDay = date.getDate().toString().padStart(2, '0');
        } else {
          this.selectedMonth = '';
          this.selectedDay = '';
        }
      }
    },
    created() {
      this.initializeFromValue();
    },
    watch: {
      value: {
        handler: 'initializeFromValue',
        immediate: true
      }
    }
  };
</script>
